/* eslint-disable react/display-name */
import React, { useState, useEffect, useRef } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import Required from './Required'
import { apiPost } from '../../Apis'
import { useDetectedDevice } from '../../WindowSize'
import Version from '../../Version'
import Waiting from '../../Waiting'
import PasswordText from './PasswordText'
import * as regs from '../../RegularExpressions'

/* ANTD */
import Button from 'antd/es/button'
import Input from 'antd/es/input'
import Alert from 'antd/es/alert'
import { openAlert } from '../../UtilsIcons'

/* ANTD MOBILE */
import Flex from 'antd-mobile/es/flex'
import WhiteSpace from 'antd-mobile/es/white-space'

import 'antd/dist/antd.css'
import 'antd-mobile/dist/antd-mobile.css'

//*Redux
import { useHistory } from 'react-router-dom'
import { connect } from 'react-redux'

const Recover = (props) => {
  const [device] = useDetectedDevice()
  const [pwd1, setPwd1] = useState(process.env.REACT_APP_PWD_PRE)
  const [pwd2, setPwd2] = useState(process.env.REACT_APP_PWD_PRE)
  const [waiting, setWaiting] = useState(true)
  const [recaptchaKey, setRecaptchaKey] = useState('')
  const [enableSend, SetEnableSend] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  // eslint-disable-next-line react/prop-types
  const currentPage = props.match.path === '/register' ? 'register' : 'recover'
  const token = new URLSearchParams(window.location.search).get('token')
  const refCaptcha = useRef('')
  const history = useHistory()

  const handleRecover = () => {
    let apiPath = process.env.REACT_APP_ENV !== "DEV" ? "connect/api/EnrollUser/EnrollUser" : "api/EnrollUser/EnrollUser"
    if (pwd1 === pwd2) {
      if (pwd1.match(regs.REGPWS)) {
        const newPost = {
          token: token,
          password: pwd1
        }
        apiPost('auth', apiPath, newPost, onSuccess, onError)
      } else { setErrorMessage('La contraseña no cumple con el formato establecido') }
    } else { setErrorMessage('Las contraseñas no coinciden') }
  }

  const onSuccess = (response) => {
    if (response.data) {
      let err = response.data.errors[0].message
      setErrorMessage(err)
    } else {
      props.tokenExpired();
      props.cleanUserProfile();
      openAlert('Acción exitosa', 'La contraseña se configuró correctamente',
        [{ text: 'Aceptar', onPress: () => onCloseAlert() }])
    }
  }

  const onError = () => {
  }

  const handleChangeData = (name, value) => {
    switch (name) {
      case 'pwd1':
        setPwd1(value)
        break
      case 'pwd2':
        setPwd2(value)
        break
      default:
    }
  }

  const closeMessage = () => {
    setErrorMessage('')
  }

  const onChangeCaptcha = (value) => {
    SetEnableSend(true)
  }

  const onCloseAlert = () => {
    history.push('/login');
  }
  useEffect(() => {
    setRecaptchaKey(Date.now().toString())
    setWaiting(false)
  }, [])

  // if (currentUserState.isAuthenticated) {
  //   return <Redirect to='/' />
  // }

  return (
    <div>
      <div className='element-body-mobile'>
        <div className="flex-container">
          {currentPage === 'recover' && (
            <div className="element-page-title">{'Ingresa tu nueva contraseña'}</div>
          )}
          {currentPage === 'register' && (
            <div className="element-page-title">{'Crear contraseña'}</div>
          )}
          <WhiteSpace size="lg" />
          <Flex>
            <Flex.Item>
              <div>
                {currentPage === 'recover' && (
                  <label className='element-form-label'>{'Nueva contraseña'}</label>
                )}
                {currentPage === 'register' && (
                  <label className='element-form-label'>{'Crear contraseña'}</label>
                )}
              </div>
              <Input.Password placeholder='' style={{ width: device === 'browser' ? '300px' : (device === 'tablet' ? '50%' : '90%') }} maxLength={250}
                onChange={e => handleChangeData('pwd1', e.target.value)}
                value={pwd1} />
              <Required required={!pwd1} />
            </Flex.Item>
          </Flex>
          <WhiteSpace size="sm" />
          <Flex>
            <Flex.Item>
              <div><label className='element-form-label'>{'Confirmar contraseña'}</label></div>
              <Input.Password placeholder='' style={{ width: device === 'browser' ? '300px' : (device === 'tablet' ? '50%' : '90%') }} maxLength={250}
                onChange={e => handleChangeData('pwd2', e.target.value)}
                value={pwd2} />
              <Required required={!pwd2} />
              {
                errorMessage !== '' && (
                  <div>
                    <WhiteSpace size="lg" />
                    <Alert message={errorMessage} closable afterClose={closeMessage} type="error" style={{ width: device === 'browser' ? '300px' : (device === 'tablet' ? '50%' : '90%') }} />
                  </div>
                )
              }
            </Flex.Item>
          </Flex>

          <WhiteSpace size="lg" />
          <Flex>
            <Flex.Item>
              {recaptchaKey &&
                <ReCAPTCHA
                  hl={'es'}
                  ref={refCaptcha}
                  sitekey={process.env.REACT_APP_CAPTCHA_KEY}
                  key={'rc' + recaptchaKey}
                  onChange={onChangeCaptcha}
                />
              }
            </Flex.Item>
          </Flex>

          <WhiteSpace size="lg" />
          <WhiteSpace size="lg" />
          <Flex justify={device === 'phone' ? 'center' : 'start'}>
            <PasswordText />
          </Flex>
          <WhiteSpace size="lg" />
          <WhiteSpace size="lg" />
          <Flex justify={device === 'phone' ? 'center' : 'start'}>
            <Button disabled={enableSend === false} onClick={handleRecover} type="primary"
              shape="round" icon="check" >{'Aceptar'}
            </Button>
          </Flex>
          <WhiteSpace size="lg" />
          <WhiteSpace size="lg" />
        </div>
      </div>
      <Version />
      <Waiting show={waiting} />
    </div>
  )
}

const mapStateToProps = state => ({

})

const mapDispatchToProps = dispatch => {
  return {
    tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
    cleanUserProfile: () => dispatch({ type: 'CLEAN_USER_PROFILE' })
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Recover)
